import type { PageContext } from "vike/types";
import type { PageData } from "@/pages/articles/@slug/+onBeforeRender";

export default (pageContext: PageContext): string =>
  (pageContext.data as PageData).title;
